qw-book-guest-detail {
  display: flex;
  flex-direction: column;
}
